import React from 'react';
import { Box } from '@material-ui/core';

export function Title(props) {
  return <Box fontWeight="bold" fontSize="14px" color="#285b49" {...props} />;
}
